import { Box } from '@mui/system';

import { ApiWorkflowDialog, TextField } from '@verantos-dev/shared-components';

import { useRenameCohortModal } from '../../hooks/useRenameCohortModal';
import { useRenameCohortModalStrings } from '../../hooks/useRenameCohortModalStrings';

export const RenameCohortModal = () => {
  const {
    isInitialLoading,
    isSubmitting,
    isValidForSubmit,
    name,
    onChangeName,
    onClose,
    onSubmit,
    renameCohortError,
  } = useRenameCohortModal();

  const { contentMessages, dialogMessages } = useRenameCohortModalStrings();

  return (
    <ApiWorkflowDialog
      id="renameCohortModal"
      title={contentMessages.title}
      onClose={onClose}
      onSubmit={onSubmit}
      isSubmitting={isSubmitting}
      dialogMessages={dialogMessages}
      submittingError={renameCohortError}
      isInitialLoading={isInitialLoading}
      isValidForSubmit={isValidForSubmit}
      hideDisplayButtonsOnSuccess
    >
      <Box style={{ paddingTop: '8px' }}>
        <TextField
          id="cohort-name-input"
          displayLabel={contentMessages.inputLabel}
          value={name}
          placeholder={contentMessages.inputPlaceholder}
          onChange={onChangeName}
          required
          maxCharacters={60}
          maxCharacterErrorMsg={contentMessages.maxCharacterErrorMsg}
          displayNumCharacter
          width="auto"
          beepMaxCharacters
        />
      </Box>
    </ApiWorkflowDialog>
  );
};
